import { Button,  Form, Typography, InputNumber } from "antd";
import { ProjectNamespace } from "../../../../_shared/namespaces/project";
import { PSacBonusWrapper, FormWrapper } from "./index.styled";
const {Text} = Typography;

interface PSacBonusComponentProps{
    project: ProjectNamespace.Project;
    onFinish? : (data?:any)=>void;
    loading?: boolean
}
export const PSacBonusComponent = (props: PSacBonusComponentProps) => {
    const {onFinish, loading, project} = props;

    return (
          <PSacBonusWrapper>
               <div className="hint" >
            <Text>
              Issue a percentage bonus to PSAC community members. Provide the maximum percentage a PSAC staker will earn below
            </Text>
            </div>
            
            {project.createdAt && <FormWrapper
                name="distribution_token"
                layout="vertical"
                initialValues={{ psacBonusPercent: project.psacBonusPercent }}
                onFinish={onFinish}
                autoComplete="off"
                >
                <Form.Item
                    label="Maximum PSAC Community Bonus (%)"
                    name="psacBonusPercent"
                    requiredMark={'optional'}
                    rules={[{ required: true, message: 'Please input a percentage!' }]}
                >
                    <InputNumber placeholder="Enter Bonus" />
                </Form.Item>
                <Form.Item >
                    <Button loading={loading} shape="round" className="submit-btn" type="primary" htmlType="submit">
                      Save
                    </Button>
                </Form.Item>
            </FormWrapper>}
          </PSacBonusWrapper>
    );
};